if (typeof window.RecentlyViewed == 'undefined') {
  window.RecentlyViewed = {};
}

RecentlyViewed.init = function (swat) {
  RecentlyViewed.swat = swat;
};

RecentlyViewed.fetchList = function () {
  return new Promise((resolve, reject) => {
    let onSuccess = async function (data) {
      resolve(data.recentlyViewed);
    };

    let onError = function (error) {
      console.error('Error while fetching the shopper activity', error);
      reject(error);
    };

    RecentlyViewed.swat.shopper.fetchRecentlyViewedProducts(onSuccess, onError);
  });
};

if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewedComponent extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector('.content-slider');
        this.productContainer = this.querySelector(`[role="list"]`);
        this.empty = this.querySelector('.wishlist-products__empty');

        this.container = this.closest('section');

        this.init();
      }

      init() {
        const interval = setInterval(() => {
          if (Wishlist.loaded) {
            clearInterval(interval);

            this.getRecentlyViewedCollection();
          }
        }, 100);
      }

      getRecentlyViewedCollection() {
        RecentlyViewed.fetchList().then((list) => {
          if (list.length == 0) {
            this.slider.classList.add('hidden');
            this.empty.classList.remove('hidden');
          } else {
            this.slider.classList.remove('hidden');
            this.empty.classList.add('hidden');

            this.productContainer.innerHTML = '';

            this.productCache = [];

            list.forEach((item, index) => {
              fetch(`${item.productUrl}?&section_id=component_wishlist-card`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const card = html.querySelector('.card');

                  this.productCache.push({
                    id: item.productId,
                    card: card,
                  });

                  if (this.productCache.length == list.length) {
                    this.productCache.sort((a, b) => {
                      return list.findIndex((item) => item.productId == a.id) - list.findIndex((item) => item.productId == b.id);
                    });

                    this.productCache.forEach((product) => {
                      let li = document.createElement('li');
                      const listItem = document.createElement('li');
                      listItem.classList.add('content__item');
                      listItem.classList.add('slider__slide');
                      listItem.classList.add('grid__item');

                      listItem.appendChild(product.card);

                      this.productContainer.appendChild(listItem);
                    });
                  }
                });
            });
          }
        });
      }
    }
  );
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(RecentlyViewed.init);
